import { IoSparklesSharp } from "react-icons/io5";
import clsx from "clsx";

const Subtitle = ({
  customIcon,
  icon,
  subtitle,
  center,
  textColor = "text-vblue2",
  gradientTextColor = "from-vblue2 via-vblue3 to-vcyan1",
  custom,
}) => {
  return (
    <strong
      className={clsx(
        "mona mb-2.5 items-center gap-1.5 font-bold tracking-widest uppercase w-full block",
        textColor,
        center === true && "mx-auto text-center justify-center",
        custom
      )}
    >
      {(icon !== false && !customIcon) ? <IoSparklesSharp className="inline-block mr-2 relative bottom-px" /> : null}

      {customIcon ? customIcon : null}
      <span className={clsx("bg-gradient-to-br bg-clip-text text-transparent", gradientTextColor)}>{subtitle}</span>
    </strong>
  );
};

export default Subtitle;
